import { ActionButton } from '@/components/ui/ActionButton';
import { BackToTop } from '@/components/ui/BackToTop';

export function QuoteActionButtons({
  onCheckout,
  onEdit,
  isCheckingOut,
  isLoadingQuote,
  showBackToTop,
}: {
  onCheckout: () => void;
  onEdit: () => void;
  isCheckingOut: boolean;
  isLoadingQuote: boolean;
  showBackToTop?: boolean;
}) {
  return (
    <div
      className={
        showBackToTop
          ? 'bg-sh-gray flex w-full flex-col items-center gap-[32px] p-[40px]'
          : 'flex flex-col items-center gap-[32px]'
      }
    >
      <div className='w-full md:w-[320px]'>
        <ActionButton
          label={isCheckingOut ? 'Processing...' : 'Continue To Checkout'}
          variant='primary'
          type='button'
          onClick={onCheckout}
          disabled={isCheckingOut || isLoadingQuote}
          className='w-full'
        />
      </div>
      <p className='text-center text-[21px] leading-[130%] font-normal'>
        Need to make changes? You can update member details, change plans, or
        add/remove members below.
      </p>
      <div className='w-full md:w-[320px]'>
        <ActionButton
          label='Update My Quote'
          variant='secondary'
          type='button'
          onClick={onEdit}
          className='w-full'
        />
      </div>
      {showBackToTop && <BackToTop />}
    </div>
  );
}
